import script from "./NwgJobStatusChip.vue?vue&type=script&setup=true&lang=js"
export * from "./NwgJobStatusChip.vue?vue&type=script&setup=true&lang=js"

import "./NwgJobStatusChip.vue?vue&type=style&index=0&id=137c013c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137c013c"]])

export default __exports__